import { SupplementType } from "services/apis/types/order/SupplementType";

export const ApproveSupplementConfirmationText: Record<keyof typeof SupplementType, string> = {
  Other: "orders.order.actions.approveSupplementQuestion",
  DueDate: "orders.order.actions.approveSupplementQuestion",
  OrderHandler: "orders.order.actions.approveSupplementQuestion",
  Cancel: "orders.order.actions.cancelQuestion",
  All: "orders.order.actions.approveSupplementQuestion"
};
